import VehicleView from './VehicleView';
export default VehicleView;
